// Theme JavaScript functionality
function toggleMoreMenu() {
  console.log("toggleMoreMenu");
  const menu = document.getElementById("moreMenu");
  menu.classList.toggle("translate-y-full");
  menu.classList.toggle("pointer-events-none");

  // Add overlay when menu is open
  const overlay = document.getElementById("menuOverlay");
  if (menu.classList.contains("translate-y-full")) {
    overlay.classList.add("hidden");
    overlay.classList.remove("block");
  } else {
    overlay.classList.remove("hidden");
    overlay.classList.add("block");
  }
}

function closeSearch() {
  const isMobile = window.innerWidth < 768; // md breakpoint
  const searchBar = isMobile
    ? document.getElementById("mobileSearchBar")
    : document.getElementById("desktopSearchBar");
  const searchInput = isMobile
    ? document.getElementById("mobileSearchInput")
    : document.getElementById("desktopSearchInput");

  // Clear the input
  if (searchInput) {
    searchInput.value = "";
  }

  // Hide the search bar
  if (searchBar) {
    if (isMobile) {
      searchBar.classList.add("translate-y-full");
    } else {
      searchBar.classList.add("-translate-y-full");
    }
    searchBar.classList.add("opacity-0");
    searchBar.classList.add("invisible");
  }
}

function toggleSearchBar() {
  const isMobile = window.innerWidth < 768; // md breakpoint
  const searchBar = isMobile
    ? document.getElementById("mobileSearchBar")
    : document.getElementById("desktopSearchBar");
  const searchInput = isMobile
    ? document.getElementById("mobileSearchInput")
    : document.getElementById("desktopSearchInput");

  if (searchBar.classList.contains("invisible")) {
    // Opening the search
    if (isMobile) {
      searchBar.classList.remove("translate-y-full");
    } else {
      searchBar.classList.remove("-translate-y-full");
    }
    searchBar.classList.remove("opacity-0");
    searchBar.classList.remove("invisible");

    // Focus the search input after a short delay to ensure the animation has started
    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
        // Select all text if there's any content
        searchInput.select();
      }
    }, 100);
  } else {
    // If search bar is already visible, just focus the input
    if (searchInput) {
      searchInput.focus();
      searchInput.select();
    } else {
      closeSearch();
    }
  }
}

// Cart functionality is now handled by cart.js

// Product page functionality
function updateQuantity(change) {
  const quantityInput = document.getElementById("quantity");
  if (quantityInput) {
    const currentValue = parseInt(quantityInput.value) || 1;
    const newValue = Math.max(1, currentValue + change);
    quantityInput.value = newValue;
  }
}

// Cart functionality is now handled by cart.js

// Collection page functionality
function initializeCollectionSorting() {
  const sortSelects = document.querySelectorAll(".sort-by");
  // Set current sort option
  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get("sort_by");

  if (sortSelects.length > 0) {
    // Handle sorting for every sortSelect on the page
    sortSelects.forEach(sortSelect => {
      if (currentSort) {
        sortSelect.value = currentSort;
      }

      sortSelect.addEventListener("change", function () {
        const url = new URL(window.location);
        url.searchParams.set("sort_by", this.value);
        window.location = url;
      });
    });
  }
}

// Collection filtering functionality
function initializeCollectionFilters() {
  // Mobile filter toggle
  const mobileFilterToggle = document.getElementById("mobile-filter-toggle");
  const mobileFilterPanel = document.getElementById("mobile-filter-panel");
  const filterChevron = document.getElementById("filter-chevron");

  if (mobileFilterToggle && mobileFilterPanel) {
    mobileFilterToggle.addEventListener("click", function () {
      const isHidden = mobileFilterPanel.classList.contains("hidden");
      if (isHidden) {
        mobileFilterPanel.classList.remove("hidden");
        filterChevron.classList.add("rotate-180");
      } else {
        mobileFilterPanel.classList.add("hidden");
        filterChevron.classList.remove("rotate-180");
      }
    });
  }
}

// Initialize theme functionality when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  const mobileSearchInput = document.getElementById("mobileSearchInput");
  const desktopSearchInput = document.getElementById("desktopSearchInput");

  // Handle escape key for mobile search
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeSearch();
      }
    });
  }

  // Handle escape key for desktop search
  if (desktopSearchInput) {
    desktopSearchInput.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeSearch();
      }
    });
  }

  // Cart badge is now handled by the Cart class in cart.js

  // Initialize collection sorting if on collection page
  initializeCollectionSorting();

  // Initialize collection filters if on collection page
  initializeCollectionFilters();
});
